/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFastqTypeUpdated = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    fileIds = _action$payload.fileIds,
    fastqType = _action$payload.fastqType;
  fileIds.forEach(function (fileId) {
    draft[secondaryAnalysisId].files.data[fileId].type = fastqType;
  });
});
export default secondaryAnalysisFastqTypeUpdated;